import { ActivityStepDraft } from "./activityStepTypes";

function withoutEndingPunctuation(value: string): string {
  return value.trim().replace(/[.:;,]+$/, "");
}

function withSentenceEnd(value: string): string {
  const text = value.trim();
  if (!text || /[.!?]$/.test(text)) return text;
  return `${text}.`;
}

export function serializeActivityStep(step: ActivityStepDraft): string {
  const text = step.text.trim();
  if (step.type === "image") {
    const instruction = withSentenceEnd(text);
    return step.imageName.trim()
      ? `${instruction} Image: ${step.imageName.trim()}`.trim()
      : instruction;
  }
  if (step.type === "video") {
    return step.url.trim()
      ? `${withoutEndingPunctuation(text)}: ${step.url.trim()}`.trim()
      : withSentenceEnd(text);
  }
  return withSentenceEnd(text);
}

export type ActivityStepListStyle = "numbered" | "-" | "*" | "•";

export function detectActivityStepListStyle(
  rawValue: string,
): ActivityStepListStyle {
  for (const rawLine of String(rawValue || "").split(/\r?\n/)) {
    const line = rawLine.trim();

    if (/^(?:\((\d+)\)|(\d+)[.)])\s*(.*)$/.test(line)) {
      return "numbered";
    }

    if (/^\*\s+(.+)$/.test(line)) return "*";
    if (/^(?:-\s+|-(?=[A-Za-z]))(.+)$/.test(line)) return "-";
    if (/^•\s*(.+)$/.test(line)) return "•";
  }

  return "numbered";
}

export function serializeActivitySteps(
  steps: readonly ActivityStepDraft[],
  listStyle: ActivityStepListStyle = "numbered",
): string {
  return steps
    .map(serializeActivityStep)
    .filter(Boolean)
    .map((step, index) =>
      listStyle === "numbered"
        ? `${index + 1}. ${step}`
        : `${listStyle} ${step}`,
    )
    .join("\n");
}